import { type NotificationAttributes } from './generated/NotificationAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Notification extends NotificationAttributes {}

@model
class Notification extends ApplicationModel {
  // Start auto-generated
  static typename: 'Notification' = 'Notification';
  get typename(): 'Notification' {
    return 'Notification';
  }

  static internalTypename: 'Notification' = 'Notification';
  get internalTypename(): 'Notification' {
    return 'Notification';
  }

  static filterType = 'NotificationFilters';
  static filters = {
    read: 'NotificationReadEnum',
    starred: 'NotificationStarredEnum',
    projectId: 'ID',
    type: '[NotificationTypeEnum!]',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    read: attr({ readable: true }),
    scope: attr({ readable: true }),
    starred: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    notifiable: attr.belongsTo({
      readable: true,
      typename: [
        'Comment',
        'Competitor',
        'DiscoveryInterview',
        'DiscoveryStudy',
        'Epic',
        'Feature',
        'Goal',
        'Idea',
        'Initiative',
        'Page',
        'Persona',
        'ProgramIncrement',
        'Project',
        'Release',
        'Task',
        'Unimplemented',
      ],
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
  };
  // End auto-generated
}

export default Notification;
